<template>
	<div>
		<a-dialog>
			<div class="summary__dialog-body">
				<section class="summary__dialog-left">
					<h1>{{ $t("leftTitle") }}</h1>
					<h2>{{ $t("elementToImprove") }}</h2>
					<results-bar :scores="bars" no-line />
					<template v-if="recommendationItems.length > 0">
						<h2>{{ $t("recommendation") }}</h2>
						<item-list
							:items="recommendationItems"
							icon="lens"
							icon-size="11"
							icon-color="secondary"
						/>
						<h3 v-if="moreRecommendationsCount">
							{{ $t("more", { moreRecommendationsCount }) }}
						</h3>
					</template>
				</section>
				<div class="summary__dialog-line" />
				<section class="summary__dialog-right">
					<div class="checkmark" v-html="$t('summary')"></div>
					<a-button :to="{ name: 'contact' }" class="summary__button">
						{{ $t("signup") }}
					</a-button>
				</section>
			</div>
		</a-dialog>
	</div>
</template>

<script>
import ResultsBar from "@/components/ResultsBar";
import ItemList from "@/components/ItemList";
import aButton from "@/components/Button";
import aDialog from "@/components/Dialog";
import survey from "@/survey";

export default {
	components: {
		ResultsBar,
		ItemList,
		aButton,
		aDialog
	},
	computed: {
		bars() {
			return {
				[survey.results.improvement.category_id]:
					survey.results.improvement.score
			};
		},
		recommendationItems() {
			if (survey.results.recommendation) {
				return [survey.results.recommendation[this.$i18n.locale]];
			}
			return [];
		},
		moreRecommendationsCount() {
			return survey.results.additionalRecommendationCount;
		},
		fullReportItems() {
			return [this.$t("item1"), this.$t("item2"), this.$t("item3")];
		}
	},
	beforeRouteEnter(to, from, next) {
		if (!survey.answers) {
			next({ name: "survey" });
		} else if (!survey.results) {
			next({ name: "summaryLoading" });
		} else {
			survey.waitForResponse(next);
		}
	},
	i18n: {
		messages: {
			en: {
				leftTitle: "Preview your result",
				elementToImprove: "Area for improvement",
				recommendation: "Our recommendation",
				signup: "Get your full report",
				more:
					"We have {moreRecommendationsCount} more recommendations for you!"
			},
			nl: {
				leftTitle: "Eerste inzicht in je resultaten",
				elementToImprove: "Element dat verbetering nodig heeft",
				recommendation: "Aanbeveling",
				signup: "Ontvang het volledige rapport",
				more:
					"We hebben nog {moreRecommendationsCount} andere vrijblijvende aanbevelingen voor je."
			}
		}
	}
};
</script>

<style lang="scss">
@import "@/styles/checkmark.scss";

.summary__dialog-body {
	display: flex;
	align-items: stretch;
}
.summary__dialog-line {
	min-width: 1px;
	min-height: 1px;
	background: #dadada;
	margin: 0 60px;
}
.summary__dialog-left,
.summary__dialog-right {
	flex: 1 1 50%;
}
.summary__button {
	margin-top: 15px;
}
@media only screen and (max-width: 909px) {
	.summary__dialog-body {
		flex-direction: column;
	}
	.summary__dialog-line {
		margin: 0 0 40px;
	}
}
</style>
